import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getTestLabels } from '../../../utils/getTestLabels.js';
import style from './InfoTag.module.scss.js';

const { componentTestLabel } = getTestLabels('InfoTag');
/**
 * [source code](https://src.private.zooplus.net/projects/FE/repos/ui-components/browse/src/components/Tag/InfoTag)
 *
 * @deprecated Use [TextBadge component](https://ui-components.private.zooplus.net/?path=/docs/components-badge-textbadge--docs) instead.
 *
 * @param {string} variant (optional) One of `primary`, `primary-solid`, `secondary`, `neutral`, ~~`grey`~~ (deprecated alias to `neutral`), `info` (default), `success`, `danger` or `warning` (deprecated alias to `danger`).
 */
const InfoTag = forwardRef((props, ref) => {
    const { children, className, variant: initialVariant = 'info', ...otherProps } = props;
    const variant = initialVariant === 'grey' ? 'neutral' : initialVariant;
    return (jsx("span", { "data-zta": componentTestLabel, ref: ref, ...otherProps, className: classNames(className, style['z-info-tag'], style[`z-info-tag--${variant}`]), children: children }));
});
InfoTag.displayName = 'InfoTag';

export { InfoTag };
//# sourceMappingURL=InfoTag.js.map
